<span class="badge badge-pedido-status badge-pedido-status-aberto-erp">
    {{status.nome}}
</span>